import { render } from "./QuestionSubmission.vue?vue&type=template&id=f3cc842c&scoped=true"
import script from "./QuestionSubmission.vue?vue&type=script&lang=js"
export * from "./QuestionSubmission.vue?vue&type=script&lang=js"

import "./QuestionSubmission.vue?vue&type=style&index=0&id=f3cc842c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3cc842c"]])

export default __exports__